__turbopack_context__.v({
  "className": "montserrat_3016f8d5-module__YWpJqq__className",
});
